import type {
  BaseShowOptions,
  QacaptchaOptions,
  QqcaptchaResponse,
} from '../typings';
import { BaseCaptcha } from './base';

export class Qqcaptcha extends BaseCaptcha {
  constructor(options: QacaptchaOptions) {
    super(options);

    this.key = 'qqcaptcha';
    this.defaultLang = 'en';
    this.url = 'https://ca.turing.captcha.qcloud.com/TCaptcha-global.js';
    this.siteKey = options.qqSiteKey;
  }

  setLang(lang: string) {
    this.lang = lang || this.defaultLang;
  }

  refresh() {
    this.captcha.destroy();
    this.captcha.show();
  }

  async initialize(options: BaseShowOptions): Promise<any> {
    if (!this.ready) {
      const loadRes = await this.load();
      if (!loadRes) {
        return false;
      }
    } else {
      this.ready = true;
    }

    const { id, callback } = options;
    this.id = id;

    /* eslint-disable @typescript-eslint/no-this-alias */
    const self = this;
    const initPms = new Promise((resolve) => {
      // If can not load in 30s, resolve false
      setTimeout(() => {
        resolve(false);
      }, 30000);
      this.captcha = new window.TencentCaptcha(
        self.siteKey,
        (resp: QqcaptchaResponse) => {
          if (resp.ret === 0) {
            callback({
              type: self.key,
              ticket: resp.ticket,
              randstr: resp.randstr,
            });
          } else {
            callback({
              type: self.key,
              error: resp.errorMessage || `[${this.key}] Valid error`,
            });
          }
        },
      );
      resolve(true);
    });
    const initRes = await initPms;
    if (!initRes) {
      console.warn(`[${this.key}] Initialize error`);
    }

    this.ready = true;
    return initRes;
  }

  async show(options: BaseShowOptions) {
    try {
      const initRes = await this.initialize(options);
      if (initRes) {
        this.captcha.show();
      }
      return initRes;
    } catch (e) {
      console.warn(`[${this.key}] ${e}`);
      return false;
    }
  }
}
